<div class="content">
  <div class="rounded-visible-container">
    <app-email-settings></app-email-settings>
  </div>
</div>

